import React from 'react';
import { arrayOf, bool, func, _object, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { propTypes } from '../../util/types';
import { createResourceLocatorString } from '../../util/routes';
import { isMainSearchTypeKeywords } from '../../util/search';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { Heading, Page, LayoutSingleColumn } from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import SearchForm from './SearchForm/SearchForm';

import css from './NotFoundPage.module.css';

function NotFoundPageComponent(props) {
  const {
    navigate,
    routeConfiguration,
    marketplaceName,
    isKeywordSearch,
  } = props;

  const title = `Page not found | ${marketplaceName}`;

  const handleSearchSubmit = values => {
    const { keywords, location } = values;
    const { search, selectedPlace } = location || {};
    const { origin, bounds } = selectedPlace || {};
    const searchParams = keywords ? { keywords } : { address: search, origin, bounds };
    navigate(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchParams));
  };

  return (
    <Page title={title}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <div className={css.content}>
            <div className={css.number}>404</div>
            <Heading as="h1" rootClassName={css.heading}>
              Page not found
            </Heading>
            <p className={css.description}>
              Sorry, we couldn't find the page you were looking for on {marketplaceName}.
            </p>
            <SearchForm
              className={css.searchForm}
              isKeywordSearch={isKeywordSearch}
              onSubmit={handleSearchSubmit}
            />
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
}



NotFoundPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  marketplaceName: string.isRequired,
  isKeywordSearch: bool.isRequired,
  routeConfiguration: arrayOf(propTypes.route).isRequired,
  navigate: func.isRequired,
};

const EnhancedNotFoundPage = props => {
  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const navigate = useNavigate();
  return (
    <NotFoundPageComponent
      routeConfiguration={routeConfiguration}
      marketplaceName={config.marketplaceName}
      isKeywordSearch={isMainSearchTypeKeywords(config)}
      navigate={navigate}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const NotFoundPage = compose(connect(mapStateToProps))(EnhancedNotFoundPage);

export default NotFoundPage;
